module.exports = __webpack_public_path__ + "static/media/misc.9d94f74a.svg";